import { render, staticRenderFns } from "./official-document-detail.view.vue?vue&type=template&id=018fe060&"
import script from "./official-document-detail.view.vue?vue&type=script&lang=ts&"
export * from "./official-document-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports